'use strict'

import angular from 'angular'

import buySheetErrorComponentHtmlUrl from './buySheetError.component.html'

angular.module('buySheet.components', []).component('buySheetError', {
    templateUrl: buySheetErrorComponentHtmlUrl,
    bindings: {
        error: '<'
    },
    controllerAs: 'vm'
})